import { createBrowserRouter } from 'react-router-dom';
import { clinicalTrialRoutes } from './ClinicalTrial.routes';
import { routesPath } from './routes';
import { Layout } from '@components/Layout/Layout';
import { ProfilePage } from '../pages/Profile/Profile';
import { NotFound } from '../pages/NotFound/NotFound';
import { QCRoutes } from '@router/QC.routes';
import { HomePage } from '../pages/Home/Home';
import { SiteUserRoutes } from '@router/SiteUser.routes';
import { usersAndLogsRoutes } from '@router/UsersAndLogs.routes';
import { SelectRole } from '../pages/SelectRole/SelectRole';
import { ErrorPage } from '../pages/Error/Error';
import { LogoutPage } from '../pages/Logout/Logout';
import { wrapWithSagaRouter } from './SagaRouter';
import { readerRoutes } from '@router/Reader.routes';
import { sponsorsRoutes } from '@router/Sponsors.routes';
import { ExternalUserRoutes } from '@router/ExternalUser.routes';
import { ValidationSpecialistRoutes } from '@router/ValidationSpecialist.routes';

export const router = createBrowserRouter(
  wrapWithSagaRouter([
    ...QCRoutes,
    ...clinicalTrialRoutes,
    ...SiteUserRoutes,
    ...ExternalUserRoutes,
    ...ValidationSpecialistRoutes,
    ...usersAndLogsRoutes,
    ...readerRoutes,
    ...sponsorsRoutes,
    {
      path: routesPath.home,
      element: <HomePage />,
    },
    {
      path: routesPath.sso,
      element: null,
    },
    {
      path: routesPath.selectRole,
      element: <SelectRole />,
    },
    {
      path: routesPath.profile,
      element: (
        <Layout>
          <ProfilePage />
        </Layout>
      ),
    },
    {
      path: routesPath.notFound,
      element: <NotFound />,
    },
    {
      path: routesPath.error,
      element: <ErrorPage error={''} />,
    },
    {
      path: routesPath.logout,
      element: <LogoutPage />,
    },
  ])
);
